module.exports = __webpack_public_path__ + "img/SKMJ_car5.68e4d61a.jpg";